import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
	providedIn: 'root'
})
export class ClientService {

	constructor(
		private http: HttpClient
	) { }

	// Creates a client during the welcome wizard
	createClient(companyName: string, name: string, email: string, billingEmail: string, customerId: string, companyId: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyName', companyName);
		params = params.set('name', name);
		params = params.set('email', email);
		params = params.set('billingEmail', billingEmail);
		params = params.set('customerId', customerId);
		params = params.set('companyId', companyId);
		params = params.set('esignType', 'dropbox');

		return this.http.post<any>(`${environment.serviceUrl}/client`, '', { headers, params });
	}

	// Looks up client detail procore configuration by company id
	getClientDetailProcoreByCompanyIdAndProjectId(companyId: number, projectId: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('projectId', projectId);

		return this.http.get<any>(`${environment.serviceUrl}/client/procore`, { params });
	}

	// Used to update the client detail procore record, after entering the secrets/keys or on the configurations page
	updateClientDetailProcore(clientDetailProcore: any, createTrial: boolean) {
		let params = new HttpParams();
		params = params.set('createTrial', createTrial);

		return this.http.put<any>(`${environment.serviceUrl}/client/procore`, clientDetailProcore, { params });
	}


	getProcoreUserConfigByCompanyId(companyId: number, username: string, procoreUserId: number, isSandbox: string) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		return this.http.get<any>(`${environment.serviceUrl}/client/user/config`, { params });
	}

	// Used to update the procore user configs on the user configurations page
	updateProcoreUserConfig(companyId: number, username: string, procoreUserId: number, isSandbox: string, procoreUserConfig: any) {
		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		return this.http.put<any>(`${environment.serviceUrl}/client/user/config`, procoreUserConfig, { params });
	}

	// Looks up a client stripe customer id and creates a new one if needed
	createClientCustomerId(email: string, name: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'text/plain');

		let params = new HttpParams();
		params = params.set('email', email);
		params = params.set('name', name);

		return this.http.post(`${environment.serviceUrl}/client/customer-id`, '', { headers, params, responseType: 'text' });
	}

	// Update project specific configurations on the configurations page
	updateProcoreProjectConfigs(configs: any, clientId: number, projectId: string) {
		let params = new HttpParams();
		params = params.set('clientId', clientId);
		params = params.set('projectId', projectId);

		const requestUrl = `${environment.serviceUrl}/client/project-configs`;

		return this.http.post<any>(requestUrl, configs, { params });
	}

	// Retrieves existing signature requests based on the current side-panel context
	getSignaturesByProcoreContext(companyId: number, context: string, username: string) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('context', context);
		params = params.set('username', username);
		params = params.set('applicationType', "DBS for Procore");

		const requestUrl = `${environment.serviceUrl}/client/signatures`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	// Retrieve a list of Dropbox Users for the current company 
	getUsers(companyId: number, username: string, procoreUserId: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/client/users`;

		return this.http.get<any[]>(requestUrl, { headers, params });
	}

	// Deletes a Dropbox User from the current company
	deleteUser(companyId: number, username: string, procoreUserId: string, deleteUsername: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('deleteUsername', deleteUsername);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/client/user`;

		return this.http.delete<any[]>(requestUrl, { headers, params });
	}

	markAsCancelled(companyId: number, signatureRequestId: string, username: string, procoreUserId: string, isSandbox: boolean) {
		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/json');

		let params = new HttpParams();
		params = params.set('companyId', companyId);
		params = params.set('signatureRequestId', signatureRequestId);
		params = params.set('username', username);
		params = params.set('procoreUserId', procoreUserId);
		params = params.set('isSandbox', isSandbox);

		const requestUrl = `${environment.serviceUrl}/client/signature/mark-as-cancelled`;

		return this.http.put<boolean>(requestUrl, '', { headers, params });
	}
}
